import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  Grid,
  Stack,
  Breadcrumbs,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import HotelIcon from "@mui/icons-material/Hotel";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MotionCard = motion(Card);

const primary = "#0d1e4a";

const opciones = [
  {
    img: "/hospedaje-opcion1.png",
    alt: "Opción 1 - Reserve a través del Comité Organizador",
    href:
      "mailto:sgiron@ebg.edu.gt?subject=" +
      encodeURIComponent("reserva COPLAFT"),
  },
  {
    img: "/hospedaje-opcion2.png",
    alt: "Opción 2 - Reserve directamente con el Hotel Barceló",
    href: "https://www.barcelo.com/es-cr/barcelo-guatemala-city/",
  },
];

export default function Hospedaje() {
  return (
    <Stack
      spacing={5}
      alignItems="center"
      style={{ background: "#f5f7f6", width: "100%" }}
      pt={3}
    >
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          to="/"
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Inicio
        </Link>

        <Typography
          sx={{ color: "text.primary", display: "flex", alignItems: "center" }}
        >
          <HotelIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Opciones de Hospedaje
        </Typography>
      </Breadcrumbs>

      <Box sx={{ py: 10 }}>
        <Container>
          <Typography variant="h4" fontWeight="bold" sx={{ color: primary }}>
            OPCIONES DE HOSPEDAJE
          </Typography>

          <Box sx={{ width: 80, height: 4, background: primary, my: 2 }} />

          <Typography sx={{ mb: 6, color: "text.secondary" }}>
            COPLAFT 2026 · Hotel Barceló · Ciudad de Guatemala
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {opciones.map((opcion, i) => (
              <Grid size={{ xs: 12, sm: 10, md: 5 }} key={i}>
                <MotionCard
                  component="a"
                  href={opcion.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.4 }}
                  sx={{
                    display: "block",
                    borderRadius: 4,
                    overflow: "hidden",
                    border: `2px solid ${primary}`,
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                >
                  <Box
                    component="img"
                    src={opcion.img}
                    alt={opcion.alt}
                    sx={{ width: "100%", display: "block" }}
                  />
                </MotionCard>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Stack>
  );
}
